var map = {
	"./full-stack-developer-card.png": "./src/static/assets/images/pages/job/full-stack-developer-card.png",
	"./trainee-graphic-designer-card.png": "./src/static/assets/images/pages/job/trainee-graphic-designer-card.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/static/assets/images/pages/job sync recursive ^\\.\\/.*\\-card\\.png$";